import * as tslib_1 from "tslib";
import { observable, action, computed } from 'mobx';
import { loading, Loadable } from '../utils/loading';
import TaskApi from '../services/TaskApi';
import { TaskStatuses } from '../models/TaskStatus';
import TaskFilter from '../models/TaskFilter';
import AppEvent from 'src/models/AppEvent';
import { TASK_UPDATE_HUB } from 'src/services/Hubs';
import { TASK_DELETING_NOT_ALLOWED } from '../constants/messages';
var TaskStore = /** @class */ (function (_super) {
    tslib_1.__extends(TaskStore, _super);
    function TaskStore(userStore) {
        var _this = _super.call(this) || this;
        _this.userStore = userStore;
        _this.sprintIndex = 0;
        _this.sprintChanged = new AppEvent();
        _this.signalrConnected = true;
        _this.onTaskChanged = function (task) {
            _this.updateTask(task);
            if (_this.tasks.some(function (i) { return i.id === task.id; }) && _this.userStore) {
                _this.userStore.notify("Feladat \u00E1llapota megv\u00E1ltozott: " + task.stepName);
            }
        };
        _this.onTaskCreated = function (task) {
            if (_this.userStore.userId === task.userId) {
                _this.addTask(task);
                _this.userStore.notify("\u00DAj feladatot kapt\u00E1l: " + task.stepName);
            }
        };
        _this.filter = new TaskFilter(_this.userStore);
        window.addEventListener('beforeunload', function () { return _this.clear(); });
        _this.connectToSignalIRHub();
        return _this;
    }
    TaskStore.prototype.connectToSignalIRHub = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, TASK_UPDATE_HUB.connect()];
                    case 1:
                        _a.sent();
                        TASK_UPDATE_HUB.taskChanged(this.onTaskChanged);
                        TASK_UPDATE_HUB.taskCreated(this.onTaskCreated);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.signalrConnected = false;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TaskStore.prototype.initialize = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, TaskApi.getTaskStatuses()];
                    case 1:
                        _a.statuses = _c.sent();
                        _b = this;
                        return [4 /*yield*/, TaskApi.getCheckListItemStatuses()];
                    case 2:
                        _b.checkListStatuses = _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskStore.prototype.updateTask = function (updated) {
        this.tasks = this.tasks.map(function (i) { return i.id === updated.id ? updated : i; });
    };
    TaskStore.prototype.loadSprint = function (sprintIndex) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sprint;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, TaskApi.getSprint(sprintIndex)];
                    case 1:
                        sprint = _a.sent();
                        this.sprintName = sprint.name;
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskStore.prototype.loadTasks = function (userId, isDisplayClosedTasks) {
        if (isDisplayClosedTasks === void 0) { isDisplayClosedTasks = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, TaskApi.getAll(userId, this.sprintIndex, isDisplayClosedTasks)];
                    case 1:
                        _a.tasks = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskStore.prototype.loadStatistic = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, TaskApi.getStatistic(userId, this.sprintIndex)];
                    case 1:
                        _a.statistic = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TaskStore.prototype, "filteredTasks", {
        get: function () {
            return this.filter.applyOn(this.tasks);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskStore.prototype, "allTimeItems", {
        get: function () {
            if (!this.tasks) {
                return [];
            }
            return this.tasks.reduce(function (items, task) {
                task.times.items.forEach(function (i) { return items.push(i); });
                return items;
            }, []);
        },
        enumerable: true,
        configurable: true
    });
    TaskStore.prototype.actualSprint = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadSprint(0)];
                    case 1:
                        _a.sent();
                        this.sprintIndex = this.sprintIndex = 0;
                        this.sprintChanged._fire(null);
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskStore.prototype.nextSprint = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadSprint(this.sprintIndex + 1)];
                    case 1:
                        _a.sent();
                        this.sprintIndex = this.sprintIndex + 1;
                        this.sprintChanged._fire(null);
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskStore.prototype.prevSprint = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadSprint(this.sprintIndex - 1)];
                    case 1:
                        _a.sent();
                        this.sprintIndex = this.sprintIndex = this.sprintIndex - 1;
                        this.sprintChanged._fire(null);
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskStore.prototype.addTask = function (task) {
        this.tasks = this.tasks.concat([task]);
    };
    TaskStore.prototype.getTasksByStatus = function (statusId) {
        return this.filteredTasks.filter(function (i) { return i.statusId === statusId; });
    };
    TaskStore.prototype.getRunningTasks = function () {
        if (!this.tasks || this.tasks.length === 0) {
            return [];
        }
        return this.tasks.filter(function (i) { return i.statusId === TaskStatuses.Doing; });
    };
    TaskStore.prototype.isNextTaskInPriorityOrder = function (task) {
        return this.tasks
            .filter(function (i) { return i.statusId < TaskStatuses.Testable; })
            .every(function (i) { return i.orderNo <= task.orderNo; });
    };
    Object.defineProperty(TaskStore.prototype, "lastTaskStatus", {
        get: function () {
            if (this.statuses && this.statuses.length > 0) {
                return this.statuses[this.statuses.length - 1].id;
            }
        },
        enumerable: true,
        configurable: true
    });
    TaskStore.prototype.getTaskById = function (id) {
        return this.tasks.find(function (i) { return i.id === id; });
    };
    TaskStore.prototype.clear = function () {
        this.sprintIndex = 0;
        this.tasks = [];
    };
    TaskStore.prototype.deleteTask = function (task) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (task.times.items.length > 0) {
                            this.userStore.notify(TASK_DELETING_NOT_ALLOWED);
                            return [2 /*return*/];
                        }
                        if (!window.confirm("Biztosan t\u00F6rli a '" + task.stepName + "' feladatot ?")) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, TaskApi.deleteTask(task)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.tasks = this.tasks.filter(function (i) { return i.id !== task.id; });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        observable
    ], TaskStore.prototype, "sprintIndex", void 0);
    tslib_1.__decorate([
        observable
    ], TaskStore.prototype, "sprintName", void 0);
    tslib_1.__decorate([
        observable
    ], TaskStore.prototype, "statistic", void 0);
    tslib_1.__decorate([
        observable
    ], TaskStore.prototype, "tasks", void 0);
    tslib_1.__decorate([
        observable
    ], TaskStore.prototype, "statuses", void 0);
    tslib_1.__decorate([
        observable
    ], TaskStore.prototype, "checkListStatuses", void 0);
    tslib_1.__decorate([
        observable
    ], TaskStore.prototype, "filter", void 0);
    tslib_1.__decorate([
        action.bound
    ], TaskStore.prototype, "updateTask", null);
    tslib_1.__decorate([
        action,
        loading
    ], TaskStore.prototype, "loadSprint", null);
    tslib_1.__decorate([
        action,
        loading
    ], TaskStore.prototype, "loadTasks", null);
    tslib_1.__decorate([
        action,
        loading
    ], TaskStore.prototype, "loadStatistic", null);
    tslib_1.__decorate([
        computed
    ], TaskStore.prototype, "filteredTasks", null);
    tslib_1.__decorate([
        computed
    ], TaskStore.prototype, "allTimeItems", null);
    tslib_1.__decorate([
        action
    ], TaskStore.prototype, "actualSprint", null);
    tslib_1.__decorate([
        action
    ], TaskStore.prototype, "nextSprint", null);
    tslib_1.__decorate([
        action
    ], TaskStore.prototype, "prevSprint", null);
    tslib_1.__decorate([
        action.bound
    ], TaskStore.prototype, "addTask", null);
    tslib_1.__decorate([
        action
    ], TaskStore.prototype, "deleteTask", null);
    return TaskStore;
}(Loadable));
export default TaskStore;



//////////////////
// WEBPACK FOOTER
// ./src/store/TaskStore.ts
// module id = 324
// module chunks = 0